// 引入axios
import axios from 'axios';
 
// 创建axios实例
const service = axios.create({
  // API的base_url
  baseURL: 'https://drmcool.top/',
  // 请求超时时间
  timeout: 5000
});
 
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可以在这里添加请求头等信息
    // 例如：config.headers['Authorization'] = 'Bearer your-token';
      config.headers['Content-Type'] ='application/json'
   
    return config;
  },
  error => {
    // 请求错误处理
    return Promise.reject(error);
  }
);
 
// 响应拦截器
service.interceptors.response.use(
  response => {
    // 对响应数据做处理，例如只返回data部分
    return response.data;
  },
  error => {
    // 响应错误处理
    return Promise.reject(error);
  }
);
 
export default service;